'use strict';

var Chart = (function () {
	
	function Chart(container, userConfig) {
		_classCallCheck(this, Chart);

		var _this = this;

		_this.config = merge(defaultUserConfig, userConfig);
		_this.userConfig = userConfig;
		_this.c = $(container);
	}

	_createClass(Chart, [{
		key: "init",
		value: function init() {

			var _this = this,
				options = merge(defaultHighstockOptions, _this.config.hs, THEMES[_this.config.theme], _this.config.themeConf);

			if (_this.config && _this.config.menu && _this.config.menu.enableOptions) {
				options.exporting.enabled = true; 
				if(_this.config.cdata.bs)
					options.exporting.filename = _this.config.cdata.bs;
			}
			if(options.chart){
				options.chart.spacingBottom = 5; 
				options.chart.spacingTop = 5; 
			}

			_this.c.empty();
			buildWrapper.call(_this);
			buildChartMenu.call(_this);
			buildBottomSettings.call(_this);

			_this.chart = _this.cnt.chart.highcharts('StockChart', options).highcharts();

			if (_this.config.useStorage) {
				merge(true, _this.config.cdata || {});
			}

			/* mouse wheel -> when you try to use mouse wheen on chart, otherwise mouse wheen scroll up/down the page */
			var mousewheelevt = /Firefox/i.test(navigator.userAgent) ? "DOMMouseScroll" : "mousewheel"; //FF doesn't recognize mousewheel as of FF3.x

			$(_this.chart.container).on(mousewheelevt, function (e) {
				typeof stop != 'undefined' ? stop = true : "";
				_this.mouseWheel(e);
			});

			_this.isFirstBuild = true;
			_this.failSafeRetry = false;
			function buildHandler() {
				var failsafe = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

				_this.build(function (err) {
					_this.isFirstBuild = false;
					_this.chart.isFirstBuild = _this.isFirstBuild;

					if (err) {
						if (!_this.failSafeRetry) {

							_this.failSafeRetry = true;
							buildHandler(true);
						};

						if (_this.failSafeRetry) {

							_this.fireEvent('build', err);
						};
					} 
					else {
						updateChartMenu.call(_this);
					}
				}, failsafe);
			}

			buildHandler();
			return _this;
		}

		//$build
		//get data based on cdata options -> rebuild series and axis
	}, {
		key: "build",
		value: function build(callback, failsafe) {

			var _this = this,
			    url = dataUrl.call(this, failsafe);
			_th = _this;

			_this.chart.showLoading();
			loadingTimeout = setTimeout(() => {_this.chart.hideLoading()}, 3000)

			getData(skipAPI, url, function (err, result) {

				// if (result.series.length > 1) {
				// 	checkResultOrder(result, _this)
				// }
				if(result == null){
					return
				}else{
					lastFailedRequest = false
				}
				if (result) {
					if (result.series) {
						if (result.series.length) {
								result = transformData('markets', data_structure_array, result)
							}
					}
				}
				var lastSocketClose = _this.chart.options.lastSocketClose ? _this.chart.options.lastSocketClose : "";
				console.log(result)
				var mainSymbol = result.series[0].symbol.toLowerCase();
				if(stopSocket == false){
					if(!isFirstCall && _this.chart.options.lastSocketClose && result.series.length == 1 && lastSocketClose[mainSymbol]){
						result.series[0].data[result.series[0].data.length-1].y = lastSocketClose[mainSymbol];
						result.series[0].data[result.series[0].data.length-1].close = lastSocketClose[mainSymbol];
					}
				}


				/*SpanChangeFunction*/
				if (loadingTimeout) {
					clearTimeout(loadingTimeout)
				}
				_this.chart.hideLoading(); /*AFTER_this.isFirstBuild = false;*/

				if(result.agr == '1m' || result.agr == '5m' || result.agr == '15m' || result.agr == '1h' || result.series.length>=2){
					for(let seriesResults = 0; seriesResults < result.series.length; seriesResults++){
						for(let changeToTimezone = 0; changeToTimezone < result.series[seriesResults].data.length; changeToTimezone ++){
							if(result.series[seriesResults].data[changeToTimezone].x){
								result.series[seriesResults].data[changeToTimezone].x += incrementTimeZone
							}
						}
				}
			}

				addInvSerie(result, _this);
				thisInterval = result.agr;
				_th.config.cdata.interval = thisInterval;
				_this.config.cdata.interval = thisInterval;
				// 1 - clean chart aka remove series/axis/labels/menus
				// 2 - Update cdata object from result
				// 3 - build chart aka series/axis/menus/labels
				// 4 - setExtremes aka adjust zoom
				if(log){ console.log("mkchart -> Series ",result.series); }

				if (_this.config.dataSource && _this.config.dataSource == 'teapi') {
					//this should be temporary meanwhile the 100% switch to SQL is made, after the Node API is down, chart.js should be changed
					result = formattResultFromTeApi(result);
				}

				if(browser == "ie"){  $(".highcharts-button-symbol").attr('width','18').attr('height','18').attr('x','10').attr('y','10'); }

				updateCdataFromResult.call(_this, result);
				_this.buildChart(result[0]);	/*Building Chart for the first time*/

				/*Update right bottom text before exporting*/
				setTimeout(function() {
					chartTitle(_th.chart.series);
				}, 1000);

				/*hiding to make options work in firefox*/
				$( ".highcharts-root:eq(1)" ).parent("div").attr('dir','ltr').hide();
				/*hiding to make options work in firefox*/

				if (_this.config.live ) { /*Connecting to IO after build the chart to display chart faster*/
					_this.connect();
				}
				for (var i in _this.chart.yAxis) {
					_this.chart.yAxis[i].removePriceLabel();
				}

				//set default
				defaultSetExtremes.call(_this, _this.config.cdata.forcedExtremes);

				if ( _this.config.live ) { // GENERATES CLOSING LABEL AND CLOSING LINE
					for (i=0;i<_this.chart.series.length;i++){
						if (_this.chart.series[i].userOptions.type == 'flags') {
							continue
						}
						var s = _this.chart.series[i],
							db_type = s.userOptions.db_type;

						//plot ticker label for all
						if (db_type != 'te' && db_type != 'financial' && _this.chart.series[i].userOptions.id != 'null:cur') {
							var val = s.yData[s.yData.length - 1][3] ? s.yData[s.yData.length - 1][3] : s.yData[s.yData.length - 1];

							s.yAxis.priceLabel({
								val: _this.config.cdata.chartType == 'percent' ? s.points[s.points.length -1].change :val
							}, _this.chart.series[i].userOptions.id.toLowerCase());
							//_this.lastBid = val;
						}
					}
				}

				if (result[0].series.length == 2) {
					_this.config.socketSymbol = result[0].series[0].serie.s;
				} else {
					_this.config.socketSymbol = false;
				}

				_this.menu.chartProfile = result[0].chart_profile || false;

				_this.isFirstBuild = false;
				if (callback) {
					callback.call(this);
				}
				if(log){ console.log("mkchart -> IS First Call:", isFirstCall); }
				var symbol = _this.menu.context;
			//Will update closeLine when the chart is first rendered with a new chart type. It solves the issue on the daily markets where the closeLine was not changing the line on update. in this case will check the last datapoint close and open

					if ((_this.series[symbol] && _this.series[symbol].config.type) && (_this.series[symbol].config.type == "candlestick" || _this.series[symbol].config.type == "ohlc")){
						_this.series[symbol].config.data[_this.series[symbol].config.data.length - 1].close >_this.series[symbol].config.data[_this.series[symbol].config.data.length-1].open ? $(".closeLine").css('stroke', 'rgb(40, 166, 154') : $(".closeLine").css('stroke', 'rgb(239, 83, 80)')
					}

				var l = result[0].series.length-1;

				$(".highcharts-series-"+l+" path:nth-child(n)").attr("display","none");
				$(".highcharts-series-"+l+":nth-child(n)").attr("display","none");
			});

			skipAPI = false;
			return _this;
		}
	}, {
		key: "update",
		value: function update(field, value, _rebuild, _doReplace) {

			//iids, interval, span, theme
			var _this = this,
			    cdata = _this.config.cdata,
			    rebuild = typeof _rebuild != 'undefined' && _rebuild == false ? false : true,
			    doReplace = _doReplace || false;

			_this.tiny = null;
			isFirstCall = false;

			let indArr = [];
				tempFlagSeries = [];
				if (field == 'span' || field == 'datePicker') {
					updateEvents = true
				} else {
					updateEvents = false
				}
				_th.chart.series.forEach((item, index) => {
					if (item.userOptions.type == 'flags') {
						indArr.push(index)
					}
				})
				indArr.sort((a, b) => b - a)
				indArr.forEach(item => {
					tempFlagSeries.push({..._th.chart.series[item].userOptions})
					_th.chart.series[item].remove()
				})

			switch (field) {
				case 'datePicker':
					if(cdata.d1 != "" || cdata.d2 != ""){
					cdata.d1 = value.d1;
					cdata.d2 = value.d2;
					}else{
						rebuild = false;
						rebuild = false;
					}
					break;
				case 'bs':
					delete cdata['interval'];
					delete cdata['d1'];
					delete cdata['d2'];

					if (doReplace) {
						cdata.series = {};
						cdata.bs = value;
					} else {
						if (cdata.bs.split(',').indexOf(value) >= 0) {
							return;
						}
						cdata.bs += (cdata.bs.length > 0 ? ',' : '') + value;
					}

					//_this.appendSocketListener(value);
					break;

				case 'bs_replace':
					if (value.constructor !== Array || value.length != 2) {
						return;
					}

					delete cdata['interval'];
					delete cdata['d1'];
					delete cdata['d2'];

					//_this.appendSocketListener(value[1]);
					break;

				case 'span':
					delete cdata['interval'];
					delete cdata['d1'];
					delete cdata['d2'];

					//if (_this.config.dataSource && _this.config.dataSource == 'teapi') {}

					cdata.span = value;
					smaCount = 0
					$("#smaLabels").remove();
					indicatorsInUse = indicatorsInUse.filter((item) => item.type != 'sma')
					$("#diffLabels").remove()
					differenceSeries = false
					break;

				case 'interval':

					cdata.interval = value;
					flagCount = 0;
					flagSeriesArr = [];
					$("#flagLabels").remove();
					$('#eventsBtn').removeClass('disabled');
	  				$('#dark-eventsBtn').removeClass('disabled');
					  smaCount = 0
					  $("#smaLabels").remove();
					  indicatorsInUse = indicatorsInUse.filter((item) => item.type != 'sma')
					  $("#diffLabels").remove()
					  differenceSeries = false
					$('#eventsMenuOption').removeClass('disabled');
					  if (isDarkMode) {
						flagsColourArr = ['#0585e9', '#fa7a16', '#e082e0', '#eea809']
					} else {
						
						flagsColourArr = ['#067f9a', '#fa7a16', '#631f7d', '#eea809']
					}
					break;

					case 'type':
						$("#diffLabels").remove()
						differenceSeries = false
						chartTypeForFlags = value;
						let smaArr
						if (_th.config.cdata.compareNumber < 2) {
							smaArr = _th.chart.series.map(el => {
								if (el.userOptions.type == "sma" && el.userOptions.id.slice(-2) !== '_2') {
									return {period: el.userOptions.params.period, colour: el.userOptions.color}
								}
							})
							smaArr = smaArr.filter(el => el !== undefined)
							smaCount = 0
							$("#smaLabels").remove();
							indicatorsInUse = indicatorsInUse.filter((item) => item.type != 'sma')
						}
						skipAPI=true;
	
						if((value == 'ohlc' || value == 'candlestick') && ((this.chart.prevType == 'line' || this.chart.prevType == 'area'))){				
							skipAPI = false
						}
	
						var series = _this.series,
							cdata_series = cdata.series || {};
	
						for (var key in series) {
	
							series[key].update({
								type: value
							}, false);
							var aux = cdata_series[key] || (cdata_series[key] = {});
							aux.type = value;
	
						}
						rebuild = true;
						_this.chart.redraw();
						if (_th.config.cdata.compareNumber < 2){
							setTimeout(()=> {
								recreateSMA(smaArr)
							}, 1000)
						}
						break;

					case 'invert':
						if(value && _this.chart.yAxis){
							//It revert the y Axis, in this case will not update the chart type because in invert/revert we need to mantain the type
							var toUpdateObject = {id: value, reversed: false, maxPadding: 0.15, minPadding: 0.05}

								for(let yAxisRow of this.chart.yAxis){
									if(yAxisRow.userOptions.id == value){
										if(yAxisRow.reversed != true){
											toUpdateObject = {id: value, reversed: true, maxPadding: 0.05, minPadding: 0.15}
										}
								}
							}
						}
						this.chart.update({
							yAxis: [
								toUpdateObject]});
								if(lastFailedRequest == true){
									skipAPI = false
								}
								else {
									skipAPI = true;
								}
						break;

						case 'axisType':
							//Update the chart type ( %, num or diff), invert/revert is not a chart Type
							var series = _this.series,
								options = value.split("-")
							for(let serieAxis in series){
								if(series[serieAxis].config.yAxis == options[options.length-1]){
									if(series[serieAxis].config.yAxis == 'y_axis_main'){
										cdata.chartType = options[0];
									}else if (series[serieAxis].config.yAxis == 'y_axis_2'){
										cdata.chartType2 = options[0];
									}else{
										cdata.chartTypeN = options[0];
									}
									series[serieAxis].config.compare = options[0]
								}
							}
				
							if(lastFailedRequest == true){
								skipAPI = false
							}
							else {
								skipAPI = true;
							}				
						break;

				case 'dt':
					delete cdata['span'];
					delete cdata['interval'];
					delete cdata['d1'];
					delete cdata['d2'];

					break;
			}

			_this.fireEvent('onOptionsChange');
			if (rebuild) {
				_this.build(function () {
					updateChartMenu.call(_this);
				});
			}

			return this;
		}
	}, {
		key: "updateCdata",
		value: function updateCdata(serieId, toUpdate) {
			var _this = this,
			    cdata = _this.config.cdata,
				scdata = cdata.series[serieId];

			if (!scdata) {
				return;
			}
			merge(true, scdata, toUpdate);
		}

		//$addSerie
	}, {
		key: "addSerie",
		value: function addSerie(bs) {
			this.update('bs', bs);
		}

		//$removeSerie
	}, {
		key: "removeSerie",
		value: function removeSerie(id) {
			var toUpdate = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

			var _this = this,
			    series = _this.series,
			    serie;

			if (Object.keys(series).length <= 0) {
				return;
			}

			var idtype = id.split(":")[1];

			if(idtype != "for" && idtype != "ran") {
				_this.removeSerieFromCdata(id);
			}

			serie = series[id];

			serie.remove();

			_th.compareSeries ? _th.compareSeries-- : _th.compareSeries = 0;

			try{ 
				if(_th.compareSeries == 0){ 
				_this.config.cdata.chartType = "auto" 
				if(isToChangeMarginsY == true){
					_th.chart.update({ chart:{ marginRight: 70, } });
				}else{
					_th.chart.update({ chart:{ marginRight: 63, } });
				}
				$(".iChart-menu2-bottom-right-horizontal").show()
			} 
		}catch(er){ console.log("chartType:", er); }

			delete series[id];
			delete _this.config.cdata.series[id];
			$(".iChart-plotLabel").hide();
			if (toUpdate) {
				_this.update();
			}
		}
	}, {
		key: "replaceSerie",
		value: function replaceSerie(oldId, newId) {
			return;
		}
	}, {
		key: "removeSerieFromCdata",
		value: function removeSerieFromCdata(id) {
			var _this = this,
			    cdata = _this.config.cdata

			var index = cdata.bs.toLowerCase().indexOf(id.toLowerCase());
			if (index < 0) {
				if(id!="null:cur"){
					return __;
				}
			}

			/* string manipulation */
			function findIndexOfBefore(str, of, index) {

				var x = index;
				while (x >= 0 && str[x] != of) {
					x--;
				}
				return x;
			};

			var from = findIndexOfBefore(cdata.bs, ',', index);
			if (from < 0) {
				from = 0;
			}

			cdata.bs = removeFromString(cdata.bs, from, index + id.length);

			function fixBsString(str) {
				var fixed = '',
					aux = str.split(','),
					count = 0;

				for (var i in aux) {
					var s = aux[i].trim();
					if (s != '') {
						fixed += (count > 0 ? ',' : '') + s;
						count++;
					}
				}
				return fixed;
			};

			cdata.bs = fixBsString(cdata.bs);

			_this.tiny = null;
		}

	},  {
		key: "fireEvent",
		value: function fireEvent(key, err) {
			var events = this.config.events,
			    fn;

			if (fn = events[key]) {
				fn.call(this, err, this.config.cdata);
			}
		}

	}, {
		key: "connect",
		value: function connect() {
			var _this = this;
			var cdata = this.config.cdata;
			var n = 0; //retries counter
			var symbol = Object.keys(_this.series)[0]; //from TE know which symbols he needs
			var TEsymbols = typeof MKTChannels !== 'undefined' ? MKTChannels : [];
			ioSymbol = Object.keys(_this.series);

			//Only connect to sockets IO if the symbol has intraday
			if (_this.series[symbol].config.frequency.toLowerCase().trim() != 'intraday') return;

			if (!_this.config.socketSymbol) {
				_this.config.socketSymbol = symbol;
			}

			var checkSymbolSubscription = function (TEsymbols, symbol) {
				for (var i = 0; i<TEsymbols.length; i++) {
					if (symbol.toLowerCase() == TEsymbols[i].toLowerCase()) {
						return true;
					} else if (i == TEsymbols.length -1) {
						return false;
					}
				}
			}

			var subscribeToSymbols = function(a) {
				socket.emit('subscribe', {
					s: [symbol]
				});
				console.log("\"connect\"", symbol)
			}

			var connectRec = function(n, cb) {
				if (n == 5) return cb(false)
				else {
					if (!socket || !socket.connected) {
						setTimeout(function() {connectRec(n+1, cb) }, 1000*5)
					} else {
						subscribeToSymbols(symbol)
						return cb(true)
					}
				}
			}

			var socketOnTick = function (cdata) {
				socket.on('tick', function (data) {
					 if (data.s.toLowerCase() == symbol.toLowerCase() && _this.config.cdata.compareNumber==1 && stopSocket == false) {
						_this.socketData(data, cdata);
					 }
				});
			}

			if (typeof socket !== 'undefined'){
				connectRec(n, function(isConnected) {
					if (isConnected)
						socketOnTick(cdata)
				})
			}

			if(ioSymbol && ioSymbol.length > 2){
				for(var i = 0; i < ioSymbol.length; i++){
					if(checkSymbolSubscription(TEsymbols, ioSymbol[i]) == false){
						console.log("unsubscribed ", ioSymbol[i])
						socket.emit('unsubscribe', {
							s: [ioSymbol[i]]
						});
					}
				}
			}
		}
	}/*, {
		key: "appendSocketListener",
		value: function appendSocketListener(s) {
			var _this = this;
			socket.emit('subscribe', {
				s: [s]
			});
		}
	}*/, {
		key: "disconnect",
		value: function disconnect() {}
		//$socketData
	}, {
		key: "socketData",
		value: function socketData(data, cdata) {			
			if (!data || !data.odt || !data.p) {
				return this;
			};	
			if (!isNaN(data.p)) {
				last_socket_value = data.p;
			}
			if(data.odt.toString().length <= 10){
				var zeroWanted = 13 - data.odt.toString().length
				if (zeroWanted == 1){
					data.odt = data.odt*10
				}else if (zeroWanted ==2){
					data.odt = data.odt*100
				}else if (zeroWanted ==3){
					data.odt = data.odt*1000
				}else if (zeroWanted ==4){
					data.odt = data.odt*10000
				}
			}
			if(data.dt.toString().length <= 10){
				var zeroWanted = 13 - data.dt.toString().length
				if (zeroWanted == 1){
					data.dt = data.dt*10
				}else if (zeroWanted ==2){
					data.dt = data.dt*100
				}else if (zeroWanted ==3){
					data.dt = data.dt*1000
				}else if (zeroWanted ==4){
					data.dt = data.dt*10000
				}
			}

			//this.lastBid = data.p;
			var _this = this,
			    chart = _this.chart,
			    symbol = data.s.toLowerCase(),
			serie = _this.series[symbol];
			var nullserie = _this.series['null:cur'];
			var lc = data.p;
			chart.options.lastSocketClose = {};
			chart.options.lastSocketClose[symbol] =  lc;

			if (!serie || !serie.s()) {
				return this;
			}

			if (!(serie.config || serie.config.session_profile) && (!data.state || data.state != 'open' || Object.keys(this.series).length > 1)) {
					return true;
			}

			var s = serie.s(),
			yAxis = s.yAxis,
			xAxis = s.xAxis,
			extremes,
			dataLen = s.data.length,
			lastDataPoint = s.data[dataLen - 1],
			prevDataPoint = s.data[dataLen - 2], 
			interval = thisInterval== "1m"? 60000 : thisInterval == "1month"? 31*24*60*60*1000 : lastDataPoint? lastDataPoint.x - s.data[dataLen - 2].x : 0,
			fixedDecimals = 2;
			//console.log(s.data)
			//console.log(prevDataPoint)
			if(isOnDiv == false){
				function setLabelDecimals1(value) {
					var val = Number(parseFloat(value).toFixed(5))
					if(val > 0.00001 && val < 0.009){
						val = Number(parseFloat(value).toFixed(6))
					}
					if (val > 10) {
						val = parseFloat(val).toFixed(3)
					}
					if (val > 100) {
						val = parseFloat(val).toFixed(2)
					}
					if (val > 1000) {
						val = parseFloat(val).toFixed(1)
					}
					if (val > 10000) {
						val = parseFloat(val).toFixed(0)
					}
					return val;
				}

				var valueToCalculation = prevDataPoint.y

				if(!valueToCalculation){
					prevDataPoint = s.data[dataLen - 3], 
					valueToCalculation = prevDataPoint.y
				}

				var chng = data.p - valueToCalculation
				if(thisInterval.charAt(thisInterval.length - 1) === 'm'){
					fixedDecimals = 3
				}
				var perC = -(((valueToCalculation-data.p)/valueToCalculation) * 100).toFixed(fixedDecimals)
				if(perC != 0){
					perC = perC.toString().indexOf('-') != -1 ? perC.toString() : '+' + perC.toString();
				}
				chng = setLabelDecimals1(chng).toString().indexOf('-') != -1 ? setLabelDecimals1(chng).toString() : '+' + setLabelDecimals1(chng).toString();
				//chng = chng.toString().indexOf('-') != -1 ? chng.toString() : '+' + chng.toString();

				$('.closeLabel').text(data.p);
				if(!isNaN(chng) && !isNaN(perC)){
					const isPercentage = checkIfPercentage(s.options.full_name)
					$('.nChange').text(chng);
					if (!isPercentage) {
						$('.percChange').text(" ("+perC+"%)");
					} else {
						$('.percChange').text(" ("+chng+"%)");
					}
					// $('.nChange').text(data.nch);
					// if (!isPercentage) {
					// 	$('.percChange').text(" ("+data.pch+"%)");
					// } else {
					// 	$('.percChange').text(" ("+data.nch+"%)");
					// }
				}

				//UPDATE THE BODYLABELS
				Number($('.highLabel').text()) < data.p ? $('.highLabel').text(data.p) : "";
				Number($('.lowLabel').text()) > data.p ? $('.lowLabel').text(data.p) : "";
				//--------------------------------------


				if(/*data.nch && data.nch.toString().indexOf('-') >= 0*/ chng && chng.toString().indexOf('-') >= 0)	{
						if(log){ console.log("mkchart -> Is change Negative? => ", chng.toString().indexOf('-') >= 0, 0); }
							$('.iChart-bodylabels-ohlc').children().find('span:nth-child(n)').removeClass('green');
							$('.iChart-bodylabels-ohlc').children().find('span:nth-child(2)').addClass('red');
							$('.iChart-bodylabels-ohlc').children().find('span:nth-child(3)').addClass('red');
						} else {
							if(log){ console.log("mkchart -> Is change Negative? => ", chng.toString().indexOf('-') >= 0, 1); }
								$('.iChart-bodylabels-ohlc').children().find('span:nth-child(n)').removeClass('red');
								$('.iChart-bodylabels-ohlc').children().find('span:nth-child(2)').addClass('green');
								$('.iChart-bodylabels-ohlc').children().find('span:nth-child(3)').addClass('green');
						}
				};
				if(log){console.log("SOCKET ODT:   " + data.odt)}	
				if(log){console.log("SOCKET DT:    " + data.dt)}	

				if(log){console.log(new Date(data.odt))}	
				if(log){console.log(new Date(data.dt))}	
					
			if (((data.odt + incrementTimeZone) - lastDataPoint.x) < interval) {
				serie.updateLastBar(data);
				if (yAxis) {
					yAxis.priceLabel({
						val: data.p
					}, symbol);
				}
			} 
			else {
				if(log){console.log('Adding new bar')}
				//FOR SOMER REASON WHEN UTC IS NEGATIVE WE NEED TO INCREMENT HERE
				if(incrementTimeZone < 0){
					data.dt += incrementTimeZone
					data.odt += incrementTimeZone
				}

				serie.addBar(data, false, cdata);
				nullserie.addBar(data, false, cdata);
				extremes = xAxis.getExtremes();

				xAxis.setExtremes(extremes.min + interval, null, false);
				$('.openLabel').text(data.p);
				$('.highLabel').text(data.p);
				$('.lowLabel').text(data.p);

				chart.redraw();
				if (yAxis) {
					yAxis.priceLabel({
						val: data.p
					}, symbol);
				}
			}


			return _this;
		}
	}, {
		key: "moveAxis",
		value: function moveAxis(side, delta) {
			var _this = this,
			    x = _this.chart.xAxis[0],
			    series = _this.chart.series[0],
			    xData = series.data,
			    trueMinX = xData[0].x,
			    trueMaxX = xData[xData.length - 1].x,
			    difMove = Math.abs(x.max - x.min),
			    weightedMove = difMove * (delta || 0.05),
			    minMove,
			    maxMove;

			if (side == 'move_left') {
				minMove = x.min - weightedMove, maxMove = x.max - weightedMove;
			} else {
				minMove = x.min + weightedMove;
				maxMove = x.max + weightedMove;
			}

			if (minMove < trueMinX) {
				minMove = trueMinX;
				maxMove = trueMinX + difMove;
			} else if (maxMove > trueMaxX) {
				maxMove = trueMaxX;
				minMove = trueMaxX - difMove;
			}
			x.setExtremes(minMove, maxMove);
			_this.chart.redraw(true);
		}
	}, {
		key: "hotkey",
		value: function hotkey(key) {
			var _this = this,
			    chart;
			if (!_this.chart) {
				return;
			}

			chart = _this.chart;

			switch (key) {
				case '+':
					chart.dkZoom('in', _this);
					break;

				case '-':
					chart.dkZoom('out', _this);
					break;
				case 'reset':
					chart.dkZoom('reset', _this);
			}
		}
	}, {
		key: "mouseWheel",
		value: function mouseWheel(e) {
			var _this = this;

			e.preventDefault();

			var chart = _this.chart,
			    evt = window.event || e,
			    //equalize event object
			delta = evt.detail ? evt.detail * -120 : evt.wheelDelta ? evt.wheelDelta : evt.originalEvent.detail * -120;

			if(Object.keys(_this.series).length > 2){
				$(".iChart-plotLabel").hide();
				$(".closeLine").hide();
			}else{
				$(".iChart-plotLabel").show();
				$(".closeLine").show();
			}

			if (delta < 0) {	
				chart.dkZoom('out', _this);
			} else {
				chart.dkZoom('in', _this);
			}
		}
	}, {
		key: "changeSerieByBs",
		value: function changeSerieByBs(originalSymbol, newSymbol) {
			const flagIndexesArr = []
			_th.chart.series.forEach((item, index) => {
				if (item.userOptions.type == 'flags') {
					flagIndexesArr.push(index)
				}
			})
			flagIndexesArr.sort((a, b) => b - a)
			for (let i = 0; i < flagIndexesArr.length ; i++) {
				_th.chart.series[flagIndexesArr[i]].remove()
			}
			flagCount = 0
			flagSeriesArr = []
			$("#flagLabels").remove();
			this.removeSerie(originalSymbol, false);
			this.removeSerie("null:cur", false);
			this.addSerie(newSymbol);
		}
	}, {
		key: "cleanSeriesExport",
		value: function cleanSeriesExport(exportType) {
			var serieToRemoveToExport
			_th.chart.navigationBindings.deselectAnnotation();
			_th.chart.annotations.forEach((annotation) => {
				if (annotation.userOptions.langKey == 'label') {
					if (exportType.type.toLowerCase() != 'image/svg+xml') {
						let formattedStr = formatTextForExport(annotation.userOptions.labels[0].text, true)
						annotation.update({labels: {text: formattedStr}})
					} else {
						annotation.update({})
					}
				}
			})
			if(indicatorsInUse.length > 0){
				const copy_th = {..._th}
				if(copy_th.chart.series[1].userOptions.id == 'null:cur'){
					serieToRemoveToExport = copy_th.chart.series[1]
					copy_th.chart.series.splice(1,1)
				}	
				copy_th.chart.exportChart(exportType);
				copy_th.chart.series.splice(1,0,serieToRemoveToExport)
			}else{
				this.chart.exportChart(exportType);
			}
			_th.chart.annotations.forEach((annotation) => {
				if (annotation.userOptions.langKey == 'label') {
					if (exportType.type.toLowerCase() != 'image/svg+xml') {
						let formattedStr = formatTextForExport(annotation.userOptions.labels[0].text, false)
						annotation.update({labels: {text: formattedStr}})
					}
				}
			})
			return;
		}
	}]);

	return Chart;
})();
//end Chart class

//blank
var IeUserConfig = {
	baseUrl: '',
	live: false,
	useStorage: true,
	menu: false,
	hs: {
		crosshairs: {
			enabled: true
		},
		customTooltip: {
			enabled: false
		},
		myAnnotations: {
			enabled: true
		}
	},
	contextMenu: {}
};

function changeToDarkMode(chart){
	console.log('Will change to dark mode')

	var darkModeChart = { 
		chart: {
			backgroundColor: {
				linearGradient: [0, 0, 500, 500],
				stops: [
						[0, 'rgb(35, 35, 35)']
				]
		}
			},
			resetZoomButton: {			
					theme: {
						fill: 'white',
						stroke: 'silver',
						r: 0,
					},
				//},
				style: {
							color: 'white',
				}
		},
		yAxis: [
			{
				id: 'y_axis_main',	
				labels: {	
					style: {
						'color': '#e3e1e1'
					}
				},
				lineColor: '#616161',
				gridLineColor: '#333333',
				tickColor: "#333333",
			},{
				id: 'yaxis_n',
				reversed: false,
				labels: {
					enabled: false
				},
				lineColor: '#616161',
				gridLineColor: '#333333',
				tickPixelInterval: 60
			},{
				id: 'y_axis_2',
				labels: {
					style: {
						'color': '#e3e1e1'
					}
				},
				gridLineColor: '#333333',
				lineColor: '#616161',
				tickColor: "#333333",
			}
		],
	}

	chart.chart.update(darkModeChart);
}

var IeChart = (function (_Chart) {
	_inherits(IeChart, _Chart);

	function IeChart(container, userConfig) {
		_classCallCheck(this, IeChart);

		_get(Object.getPrototypeOf(IeChart.prototype), "constructor", this).call(this, container, merge(IeUserConfig, userConfig));

		this.init();
		var container = this.chart.container;

		$(function() {
			$(".highcharts-root")
				.mouseover(function() { isOnDiv = true; })
				.mouseout(function() { isOnDiv = false; })
		});
	}

	_createClass(IeChart, [{
		key: "init",
		value: function init() {
			_get(Object.getPrototypeOf(IeChart.prototype), "init", this).call(this);
		}
	}, {
		key: "buildChart",
		value: function buildChart(result) {
			isDarkMode == true ? changeToDarkMode(this) : null;
			if(result.series && result.series.length >= 2) {
				if(isToChangeMarginsY2 == true || isToChangeMarginsY == true){
					this.chart.update({ chart:{ marginLeft: 70, marginRight: 70,} });
				}else{
					this.chart.update({ chart:{ marginLeft: 63, marginRight: 63,} });
				}
			}
			else {
				neutralAxisMargin = false;
				secondaryAxisMargin = false;
				mainAxisMargin = true;
				this.chart.update({ chart:{ marginLeft: 8, } });
			}

			//UPDATE MARGINS OF CHART
			if(neutralAxisMargin == true){
				//main
				this.chart.update({ chart:{ marginRight: 0, } });
				$(".iChart-menu2-bottom-right-horizontal").hide()
				//secondary
				$(".iChart-menu2-bottom-left-horizontal").hide();
				$('#iChart-bodyLabels-cntx').css("left","0")
				$(".iChart-menu2-bottom-cnt-horizontal").css("margin-left","45px")
				this.chart.update({ chart:{ marginLeft: 0, } });
			}else{
				//main
				if(isToChangeMarginsY == true || isToChangeMarginsY2 == true){
					this.chart.update({ chart:{ marginRight: 70, marginLeft: 70} });
				}else{
					this.chart.update({ chart:{ marginRight: 63, marginLeft: 63, } });
				}
				$(".iChart-menu2-bottom-right-horizontal").show()
				//secondary
				/*if(isToChangeMarginsY2 == true){
					this.chart.update({ chart:{ marginLeft: 70, } });
				}else{
					this.chart.update({ chart:{ marginLeft: 63, } });
				}*/
				$(".iChart-menu2-bottom-left-horizontal").show()
				$('#iChart-bodyLabels-cntx').css("left","60px");
				$(".iChart-menu2-bottom-cnt-horizontal").css("margin-left","-17px")
			}

			if(mainAxisMargin == true){
				if(isToChangeMarginsY == true){
					this.chart.update({ chart:{ marginRight: 70, } });
				}else{
					this.chart.update({ chart:{ marginRight: 63, } });
				}
				$(".iChart-menu2-bottom-right-horizontal").show()
			}else{
				this.chart.update({ chart:{ marginRight: 0, } });
				$(".iChart-menu2-bottom-right-horizontal").hide()
			}
			if(secondaryAxisMargin == true){
				if(isToChangeMarginsY2 == true || isToChangeMarginsY == true){
					this.chart.update({ chart:{ marginLeft: 70, marginRight: 70,} });
				}else{
					this.chart.update({ chart:{ marginLeft: 63, marginRight: 63,} });
				}
				$(".iChart-menu2-bottom-left-horizontal").show()
				$('#iChart-bodyLabels-cntx').css("left","50px");
				$('#iChart-bodyLabels-cntx').css("top","45px");
				$(".iChart-menu2-bottom-cnt-horizontal").css("margin-left","-17px")
			}else{
				$(".iChart-menu2-bottom-left-horizontal").hide();
				$('#iChart-bodyLabels-cntx').css("left","0 !important")
				$(".iChart-menu2-bottom-cnt-horizontal").css("margin-left","45px")
				this.chart.update({ chart:{ marginLeft: 0, } });
			}

			if (_th.config.cdata.compareNumber > 1) {
				$(".iChart-menu2-bottom-cnt-horizontal").addClass("compare")
			} else {
				$(".iChart-menu2-bottom-cnt-horizontal").removeClass("compare")
			}
			/*build xAxis yAxis and series*/
			IE_removeAxis.apply(this.chart); //Remove X axis
			IE_buildXAxis.apply(this, [result]); //Build X Axis
			IE_buildChart.apply(this, [result]); // Main Build

			if(result.series.length >= 6) {
				// $("#compareBtn").addClass("d-none"); 
				// $("#dark-compareBtn").addClass("d-none"); 
				$("#compareBtn").addClass("disabled"); 
				$("#dark-compareBtn").addClass("disabled"); 
			}
			else {
				$("#compareBtn").removeClass("d-none"); 
				$("#dark-compareBtn").removeClass("d-none");
				$("#compareBtn").removeClass("disabled");
				$("#dark-compareBtn").removeClass("disabled");
			}

			if(result.series.length <= 2) {
				setTimeout(function() {
					$(".expand-search").removeClass("disableClick"); 
				}, 0);
			}

		}
	}]);
	return IeChart;
})(Chart);

function IE_removeAxis() {
	var xAxis = this.xAxis;

	while (xAxis.length > 0) {
		xAxis[0].remove();
	}
};

var lastTickText = "";
var lastFormatterValue;
// current build x axis
function IE_buildXAxis(result) {
	
	var _this = this,
	    chart = _this.chart,
	    series = result.series,
	    maxFreq = result.chartFrequency || (result.frequency ? result.frequency.max : series[0].serie.frequency),
	    mainX = {
		id: 'mainX',
		type: 'datetime',
		startOnTick: false,
		endOnTick: false,
		dateTimeLabelFormats: {
			day: '%e',
			hour: '%H:%M',
			minute: '%H:%M',
			month: '%b',
			year: '%Y'
		},
		ordinal: maxFreq == 'intraday' || series.length == 2 && maxFreq == 'daily' ? true : false,
		labels: {
			enabled: true,
			y: 20,
			autoRotation: false,
			rotation: false,
			useHTML: true,
			style: {
				'font-size': regularFontSize,
				'font-weight': '400',
				'color': isDarkMode == true ? '#e3e1e1' : 'black',
			},
			formatter: function formatter() {
				
				var series = this.chart.series,
					unique = _this.config.cdata.unique;

				var d = new Date(this.value);

				if (unique) {
					var d = new Date(this.value);
					switch (unique) {
						case 'quarterly':
							return monthToQuarter(d.getMonth()) + ' ' + d.getFullYear();
					}
				} else if (series[0] != undefined) {
					if (series[0].options.frequency == 'quarterly' && series[0].options.db_type == 'financial') {
						var quarter = monthToQuarter(d.getMonth());

						return quarter.toLowerCase() == 'q1' ? monthToQuarter(d.getMonth()) + ' ' + d.getFullYear() : quarter;
					}
				}

				if(series[0] != undefined) {
					if (thisInterval.trim() == "1month" && Highcharts.dateFormat('%Y', this.value) != lastTickText) {
						lastTickText = Highcharts.dateFormat('%Y', this.value);
						return Highcharts.dateFormat('%Y', this.value);
					}
					else if (thisInterval.trim() == "1month" && Highcharts.dateFormat('%Y', this.value) == lastTickText) {
						lastTickText = Highcharts.dateFormat('%Y', this.value);
						return Highcharts.dateFormat('%b', this.value);
					}
					else if(thisInterval.trim() == "1w" && lastFormatterValue && Highcharts.dateFormat('%Y', this.value) != Highcharts.dateFormat('%Y', lastFormatterValue)) {
						const this_date = new Date(this.value);
						const this_month = this_date.getUTCMonth();
						const this_day = this_date.getUTCDate();
						if (this_month == 0 && this_day == 1) { 
							lastTickText = Highcharts.dateFormat('%Y', this.value);
							lastFormatterValue = this.value;
							return Highcharts.dateFormat('%Y', this.value);
						} else {
							lastTickText = Highcharts.dateFormat('%b', this.value);
							lastFormatterValue = this.value;
							return Highcharts.dateFormat('%b', this.value);
						}
					}
					else if(thisInterval.trim() == "1d" && lastFormatterValue && Highcharts.dateFormat('%Y', this.value) != Highcharts.dateFormat('%Y', lastFormatterValue) && !this.isFirst) {
						lastTickText = Highcharts.dateFormat('%Y', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%Y', this.value);
					}
					else if(thisInterval.trim() == "1d" && Highcharts.dateFormat('%b', this.value) != lastTickText) {
						lastTickText = Highcharts.dateFormat('%b', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%b', this.value);
					}
					else if(thisInterval.trim() == "1d" && Highcharts.dateFormat('%b', this.value) == lastTickText) {
						lastTickText = Highcharts.dateFormat('%b', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%e', this.value);
					}
					else if(thisInterval.trim() == "4h" && lastFormatterValue && Highcharts.dateFormat('%b', this.value) != Highcharts.dateFormat('%b', lastFormatterValue)) {
						lastTickText = Highcharts.dateFormat('%b', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%b', this.value);
					}
					else if(thisInterval.trim() == "4h" && lastFormatterValue && Highcharts.dateFormat('%e', this.value) == Highcharts.dateFormat('%e', lastFormatterValue)) {
						lastTickText = Highcharts.dateFormat('%H:%M', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%H:%M', this.value);
					}
					else if (thisInterval.trim() == "4h" && !this.isFirst) {
						lastTickText = Highcharts.dateFormat('%e', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%e', this.value);
					}
					else if ( Highcharts.dateFormat('%b', this.value) != Highcharts.dateFormat('%b', lastFormatterValue)) {
						lastTickText = Highcharts.dateFormat('%b', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%b', this.value);
					}
					else if ( Highcharts.dateFormat('%e', this.value) != Highcharts.dateFormat('%e', lastFormatterValue)) {
						lastTickText = Highcharts.dateFormat('%e', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%e', this.value);
					}
					else if ( Highcharts.dateFormat('%e', this.value) == Highcharts.dateFormat('%e', lastFormatterValue)) {
						lastTickText = Highcharts.dateFormat('%H:%M', this.value);
						lastFormatterValue = this.value;
						return Highcharts.dateFormat('%H:%M', this.value);
					}
					else {
						if(this.chart.series[0].processedXData.length >20 ){
							if (this.isFirst && this.dateTimeLabelFormat == '%e' || this.isFirst && this.dateTimeLabelFormat == '%H:%M') {
								lastFormatterValue = this.value;
								return Highcharts.dateFormat('%b', this.value);
							}else {
								lastFormatterValue = this.value;
								return Highcharts.dateFormat('%e', this.value);
							}
						}
						else {
							if (this.isFirst && this.dateTimeLabelFormat == '%H:%M') {
								lastFormatterValue = this.value;
								return Highcharts.dateFormat('%e', this.value);
							}
						}
					}
				}
				return Highcharts.dateFormat(this.dateTimeLabelFormat, this.value);
			}
		},
		gridLineWidth: 1,
		gridLineColor: isDarkMode == true ? '#333333': '#EDF3F6',
		tickWidth: 0,
		tickPixelInterval: 130,
		lineColor: isDarkMode == true ? '#616161': '#E6E6E6',
		tickColor: isDarkMode == true ? '#333333': '#EDF3F6',
		
		tickPositioner: function (min, max) {
			if (this.series[0] != undefined) {
				try {

					var min = this.min;
					var arr = this.tickPositions;
					var arrPad = this.paddedTicks;
					var difMin;
					var difMonth = 12*30*24*60*60*1000;
					var difWeek = 12*7*24*60*60*1000;
					var difDay = 12*24*60*60*1000;
					var dif4h = 12*4*60*60*1000;
					var difh = 12*60*60*1000;
					var difminute = 12*60*1000;
					var padding;
					const tickPositionsInfo = this.tickPositions.info;
					if (arrPad != undefined && arr[0] > arrPad[0] || arr[0] >= min || arrPad == undefined) {
						difMin = arr[0]- min;
						padding = false;
					}
					else if (arrPad != undefined && arr[0] <= arrPad[0]) {
						difMin = arr[1]- min;
						padding = true;
					}
					else {
						difMin = arr[0]- min;
					}

					if (padding == true) {
						if(difMin < difMonth && thisInterval == "1month") {

							if (arr.length >= 10) {
								arr.shift();
							}
							else if(arr.length >= 8) {
								arr.shift();
								arr.shift();
							}
							else if(arr.length == 7) {
								arr.shift();
							}
						}
						else if(difMin < difDay && thisInterval == "1d") {

							if (arr.length >= 8) {
								arr.shift();
								arr.shift();
							}
							else if (arr.length == 7) {
								arr.shift();
							}
						}
						else if (difMin < dif4h && thisInterval == "4h"){

							if (arr.length >= 8) {
								arr.shift();
							}
							else if (arr.length == 7) {
								arr.shift();
							}
						}
						else if(difMin < difWeek && thisInterval == "1w") {

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if (difMin < difh && thisInterval == "1h"){

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if (difMin < difminute && thisInterval == "1m"){

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
					}
					else {
						if(difMin < difMonth && thisInterval == "1month") {

							if(arr.length >= 10){
								arr.shift();
							}
							else if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if(difMin < difDay && thisInterval == "1d") {

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if (difMin < dif4h && thisInterval == "4h"){

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if(difMin < difWeek && thisInterval == "1w") {

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if (difMin < difh && thisInterval == "1h"){

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
						else if (difMin < difminute && thisInterval == "1m"){

							if(arr.length >= 8){
								arr.shift();
							}
							else if(arr.length == 7){
								arr.shift();
							}
						}
					}
					//added to fix an issue with labels on 5y span
					if (arr.length - 2 == getYearDifference(this.max, this.min)){
						for (let i = 0; i < arr.length - 1; i++) {
							arr[i] = getBeginningOfYear(arr[i]);
						}

					}
					arr.info = tickPositionsInfo;
					return arr;
				}
				catch (err) { console.log('error: ', err); }
			}
		}
	};

	chart.addAxis(mainX, true, false);

	for (var i in series) {
		(function (s) {

			if (s.serie) {
				s = s.serie;
			}
			if (s.frequency == maxFreq) {
				return;
			}

			var id = 'xAxis_' + s.frequency.toLowerCase(),
			    axis_obj = {
				id: id,
				type: 'datetime',
				startOnTick: false,
				ordinal: s.frequency == 'intraday' ? true : false,
				labels: {
					enabled: false,
					y: 15,
					autoRotation: false,
					rotation: false,
					useHTML: true,
					step: 2
				},
				tickWidth: 0,
				tickPixelInterval: $(window).width() <= 600 ? 50 : 80,
				lineWidth: 0,
				visible: false
			};

			var exists = chart.get(id);
			if (!exists) chart.addAxis(axis_obj, true, false);
		})(series[i].serie);
	}
};

async function IE_buildChart(result) {

	var _this = this,
	    config = _this.config,
	    cdata = config.cdata,
	    chartType = cdata.chartType ? cdata.chartType.toLowerCase() : 'auto',
	    chartType2 = cdata.chartType2 ? cdata.chartType2.toLowerCase() : 'auto',
	    chartTypeN = cdata.chartTypeN ? cdata.chartTypeN.toLowerCase() : 'auto',
	    series = _this.series ? _this.series : _this.series = {},
	    rSeries = result.series,
	    chart = _this.chart,
	    has2 = false,
	    maxFreq = result.chartFrequency || (result.frequency ? result.frequency.max : rSeries[0].serie.frequency);
	chart.colorCounter = 0;
	_th = _this;
	
	if(!jQuery.isEmptyObject(annotationsInUse)){
		setTimeout(()=>{
			recreateAnnotation()
		},100)
	}

	chart.updateHook = function (cb) {
		_this.update(function () {
			if (cb) {
				cb(true);
			}
		});
	};

	all_serires = []
	for (var i in rSeries) {

		(function (s, _i) {
			if (s.serie) {
				s = s.serie;
			}
			if(s.symbol != "null:cur"){
				var series_found = false;
				for(var i = 0; i < all_serires.length; i++){
					if(all_serires[i].symbol.toLowerCase().toString() === s.symbol.toLowerCase().toString()){
						all_serires[i] = s;
						series_found = true;
					}
				}
				if(!series_found) all_serires.push(s)
			}
		})(rSeries[i].serie, i);
	}

	for (var i in rSeries) {
		(function (s, _i) {

			if (s.serie) {
				s = s.serie;
			}

			var s_id = s.s,
			setSerieAxis = function setSerieAxis(i) {

				var axis;

				if (cdata.secondSymbol && saveUserSelections[cdata.secondSymbol.toLowerCase()]) {
					if (!saveUserSelections[cdata.secondSymbol.toLowerCase()].yaxis && s_id == cdata.secondSymbol.toLowerCase()) {
						return 'y_axis_2';
					}
				}

				if (cdata.thirdSymbol && saveUserSelections[cdata.thirdSymbol.toLowerCase()]) {
					if (!saveUserSelections[cdata.thirdSymbol.toLowerCase()].yaxis && s_id == cdata.thirdSymbol.toLowerCase()) {
						return 'yaxis_n';
					}
				}

				if (s_id == "null:cur") {
					axis = 'y_axis_main';
				}
				else {
					if (!has2)
					{
						has2 = true;
						axis = 'y_axis_main';
					}
					else {
						axis = 'y_axis_2';
					}
				}

				if (!saveUserSelections[s_id].yaxis) {
					saveUserSelections[s_id].yaxis = axis;
					return saveUserSelections[s_id].yaxis;
				}
				else {
					return saveUserSelections[s_id].yaxis;
				}
			}

			if (!saveUserSelections[s_id]) {
				saveUserSelections[s_id] = {}
			}
			if (!saveUserSelections[s_id].color) {
				saveUserSelections[s_id].color = chart.options.colors[chart.colorCounter];
			}
			chart.colorCounter++;

			//serie to chart
			var s_cdata = cdata.series[s_id] || {},
			    s_color = saveUserSelections[s_id].color,
			    s_yaxis = setSerieAxis(),
			    s_type = s_cdata.type || 'line',
				s_obj = {
					id: s_id,
					isMain: cdata.mainSymbol == s_id ? true : false,
					shortname: s.shortname || s.name || s.s,
					fullname: s.name || s.fullname || '',
					full_name:s.full_name,
					unit: s.unit || '',
					frequency: s.frequency,
					db_type: s.type,
					title: s.title,
					nDecimals: !s.hasOwnProperty('nDecimals') ? s.decimals : s.nDecimals,
					iso2: s.iso2,
					socketSymbol: s.socketSymbol,
					session_profile: s.session_profile,
					allowed_candles: s.allowed_candles,
					highDif: s.highDif || 0,
					lowDif: s.lowDif || 0,
					type: isUpdate ? s_type : defaultChartType,
					data: s.data,
					f_iids: s.f_iids || '',
					xAxis: maxFreq == s.frequency ? 'mainX' : 'xAxis_' + s.frequency.toLowerCase(),
					yAxis: s_yaxis,
					myColor: s_color,
					fillOpacity: 0.2,
					fillColor: {
						linearGradient: {
							x1: 0,
							y1: 0,
							x2: 0,
							y2: 1
						},
						stops: [[0, s_color], [1, Highcharts.Color(s_color).setOpacity(0).get('rgba')]]
					},
					gapSize: false,
					events: {
						onremoveclick: function onremoveclick(symbol) {

							symbol = symbol.toLowerCase();
							console.log('REMOVING SYMBOL ----------------- ', symbol);

							for (var i in saveUserSelections) {
								delete saveUserSelections[i].color;
							}

							if (cdata.secondSymbol)
								if (cdata.secondSymbol.toLowerCase() == symbol) cdata.secondSymbol = null;

							if (cdata.thirdSymbol)
								if (cdata.thirdSymbol.toLowerCase() == symbol) cdata.thirdSymbol = null;

							if (cdata.fourthSymbol)
								if (cdata.fourthSymbol.toLowerCase() == symbol) cdata.fourthSymbol = null;

							if (cdata.fifthSymbol)
								if (cdata.fifthSymbol.toLowerCase() == symbol) cdata.fifthSymbol = null;

							// Re-organizing the symbols after one is deleted
							var activeSymbols = []
							if (cdata.secondSymbol) activeSymbols.push(cdata.secondSymbol);
							if (cdata.thirdSymbol) activeSymbols.push(cdata.thirdSymbol);
							if (cdata.fourthSymbol) activeSymbols.push(cdata.fourthSymbol);
							if (cdata.fifthSymbol) activeSymbols.push(cdata.fifthSymbol);

							var all_serires_aux = all_serires;
							all_serires[1] = null;
							all_serires[2] = null;
							all_serires[3] = null;
							all_serires[4] = null;

							console.log('all_serires_aux', all_serires_aux)

							for (var i = 1; i <= 4; i++) {
								try {
									if (all_serires_aux[i] && all_serires_aux[i].symbol == activeSymbols[0]) {
										all_serires[1] = all_serires_aux[i];
									}

									if (all_serires_aux[i] && all_serires_aux[i].symbol == activeSymbols[1]) {
										all_serires[2] = all_serires_aux[i];
									}

									if (all_serires_aux[i] && all_serires_aux[i].symbol == activeSymbols[2]) {
										all_serires[3] = all_serires_aux[i];
									}
								}
								catch(error) { console.log(error); }
							}

							for (var i in all_serires) {
								if (all_serires[i] == null) {
									all_serires.splice(i, 1);
								}
							}

						
							if(activeSymbols.length == 0){
								$(".iChart-menu2-bottom-left-horizontal").hide();
								$(".iChart-menu2-bottom-cnt-horizontal").css("margin-left","45px")

								if(isMobile){
									$('.iChart-control-bar-wrapper').css('margin-right', '60px')
								}
							}

							delete cdata.secondSymbol;
							delete cdata.thirdSymbol;
							delete cdata.fourthSymbol;
							delete cdata.fifthSymbol;

							if (activeSymbols[0]) cdata.secondSymbol = activeSymbols[0];
							if (activeSymbols[1]) cdata.thirdSymbol = activeSymbols[1];
							if (activeSymbols[2]) cdata.fourthSymbol = activeSymbols[2];
							if (activeSymbols[3]) cdata.fifthSymbol = activeSymbols[3];

							cdata.compareNumber = cdata.compareNumber -1;
							
							var labels;
							if (_this.menu && (labels = _this.menu.options['labels'])) {
								var l = labels.labels[symbol];
								if (l) l.remove();
								delete labels.labels[symbol];
							}

							_this.removeSerie(s_id);
						},
						onOptionsChange: function onOptionsChange(toUpdate) {

							if (typeof toUpdate.type !== 'undefined') {
								_this.update(toUpdate, true);
							}
							else {
								_this.series[s_id.toString()].update(toUpdate, true);
							}
							_this.series[s_id.toString()].update(toUpdate, true);
							_this.updateCdata(s_id, toUpdate);
						},
					}
				};

			if (s.socketSymbol) {
				s_obj.socketSymbol = s.socketSymbol;
			}

			if (s_obj.yAxis == "y_axis_main") {
        s_obj.compare = chartType;
      } else {
        s_obj.compare = chartType2;
      }

			var newS = new MySerie(chart, s_obj);
			series[s_id] = newS;

			/*CHECK THIS LATER*/
			if (isFirstCall == false && isUpdate == false && 
				defaultChartType == 'line' || isFirstCall == false && 
				isUpdate == false && defaultChartType == 'area') {//bruno

					var value = defaultChartType;
					var cdata_series = cdata.series || {};

				for (var key in series) {
					series[key].update({
						type: value
					}, false);
					var aux = cdata_series[key] || (cdata_series[key] = {});
					aux.type = value;
				}
				if (value == "line" || value == "area" || cdata.chartType == 'percent') {
					$(".closeLine").attr('stroke', 'blue');
				}
			}

			if (i == rSeries.length-1) {
				isUpdate = true;
			}

		})(rSeries[i].serie, i);
	}
	if (_th.config.cdata.compareNumber > 1) {
		flagCount = 0
		flagSeriesArr = []
		$("#flagLabels").remove();
		if (isDarkMode) {
			flagsColourArr = ['#0585e9', '#fa7a16', '#e082e0', '#eea809']
		} else {
			
			flagsColourArr = ['#067f9a', '#fa7a16', '#631f7d', '#eea809']
		}
		smaCount = 0
		$("#smaLabels").remove();
		indicatorsInUse = indicatorsInUse.filter((item) => item.type != 'sma')
		$("#diffLabels").remove()
		differenceSeries = false
	}
	if (_th.config.cdata.compareNumber == 1) {
		_th.chart.yAxis[2].update({lineColor: null})
	} else {
		_th.chart.yAxis[2].update({lineColor: isDarkMode == true ? '#616161': '#E6E6E6'})
	}
	if(isToChangeMarginsY == true){
		_th.chart.update({ chart:{ marginRight: 70, } });
		$("#cogWheel-y_axis_main").addClass("expandcog")
	}else{
		$("#cogWheel-y_axis_main").removeClass("expandcog")
	}
	if(secondaryAxisMargin == true){
			if(isToChangeMarginsY2 == true || isToChangeMarginsY == true){
				_th.chart.update({ chart:{ marginLeft: 70, marginRight: 70,} });
				$("#cogWheel-y_axis_2").addClass("expandcog")
				$("#cogWheel-y_axis_main").addClass("expandcog")
			}else{
				_th.chart.update({ chart:{ marginLeft: 63, marginRight: 63,} });
				$("#cogWheel-y_axis_2").removeClass("expandcog")
				$("#cogWheel-y_axis_main").removeClass("expandcog")
			}
	}else{
		_th.chart.update({ chart:{ marginLeft: _th.config.cdata.compareNumber < 2 ? 8 : 0, } });
	}

	if (tempFlagSeries.length > 0 && _th.config.cdata.compareNumber < 2) {
		if (updateEvents) {
			const source = params.source
			const epsFlagToUpdate = flagSeriesArr.find((item) => item.slice(-4).toLowerCase() == ':eps')
			const flagsToUpdate = flagSeriesArr.filter((item) => item.slice(-4).toLowerCase() != ':eps')
			const additionalEvents = []
			var TESecurify = 'sesame'
			let span = cdata.span.toLowerCase()
			let time_period = '';
			if (_th.config.cdata.d1 && _th.config.cdata.d2 && _th.config.cdata.d1 != null && _th.config.cdata.d2 != null) {
				time_period = `&d1=${_th.config.cdata.d1}&d2=${_th.config.cdata.d2}`
			} else {
				time_period = `&span=${span}`
			}
			time_period = time_period.slice(1)
			if (epsFlagToUpdate) {
				let requestUrlStr
				requestUrlStr = `https://d3ii0wo49og5mi.cloudfront.net/economics/${epsFlagToUpdate}?${time_period}&securify=new&url=${TESecurifyUrl}&AUTH=${TESecurify}`

				let response = await fetch(requestUrlStr)
				let result = await response.json()
				if (result[0].series && result[0].series.length > 0) {
					result[0].series.forEach((ele) => {
						ele.serie.data = [...transformData('earnings', earnings_structure_array, ele.serie.data)];
						additionalEvents.push(ele)
					})
				}
			}
			if (flagsToUpdate.length > 0) {
				let symbolStr = ''
				flagsToUpdate.forEach((item) => {
					symbolStr += item.split(":te")[0].replace(' ', '%20') + ','
				})
				symbolStr = symbolStr.slice(0, -1)
				let requestUrlStr = `https://d3ii0wo49og5mi.cloudfront.net/events/${symbolStr}?${time_period}&securify=new&url=${TESecurifyUrl}&AUTH=${TESecurify}`;		
				console.log(requestUrlStr)
				let response = await fetch(requestUrlStr)
				let result = await response.json()
				if (result[0].series && result[0].series.length > 0) {
					result[0].series.forEach((ele) => {
						ele.serie.data = [...transformData('calendar', calendar_structure_array, ele.serie.data)];
						additionalEvents.push(ele)
					})
				}
			}
			console.log(additionalEvents);
			additionalEvents.forEach((item) => {
				let  isEPS = false
				console.log(item)
				console.log(item.serie.s)
				if (item.serie.s){
					if (item.serie.s.slice(-4).toLowerCase() == ':eps') {
						isEPS = true
					}
				}
				let tempSeries
				let tempSeriesIndex = -1;
				if (item.serie.symbol){
					for (let index = 0; index < tempFlagSeries.length; index++) {
						if (tempFlagSeries[index].symbol.split(":te")[0] == item.serie.symbol) {
							tempSeriesIndex = index
							tempSeries = tempFlagSeries[index]
						}
						
					}
				} else if (item.serie.s){
					for (let index = 0; index < tempFlagSeries.length; index++) {
						if (tempFlagSeries[index].symbol == item.serie.s) {
							tempSeriesIndex = index
							tempSeries = tempFlagSeries[index]
						}
					}
				}
				if (item.serie.data && tempSeries) {
					const flagColour = tempSeries.fillColor
					const eventsData = item.serie.data
					const updatedData = []
					eventsData.forEach((currentEvent, index) => {
						if (isEPS && index == 0) {
							if (currentEvent.x < _th.chart.series[0].data[0].x) {
								return
							}
						}
						let dateOptions = { year: 'numeric', month: 'long', day: 'numeric' }
						let currentEventDate = new Date(currentEvent.date).toLocaleDateString(undefined, dateOptions)
						let currentEventText = currentEvent.event_name
						let actual = currentEvent.actual
						let forecast = currentEvent.forecast
						let country = currentEvent.country
						const close = currentEvent.close
						const refDate = currentEvent.referenceDate
						const name = item.serie.shortname || item.serie.name || ""
						let currentEventData = {
							x: currentEvent.x,
							title: isEPS? close :  actual,
							text: `<span class="tooltipDate">${currentEventDate}</span><br><span class="tooltipText" style="color: ${flagColour};">${country} ${currentEventText}</span><br><span>Actual: </span><span class="tooltipActual" style="color: ${flagColour};">${actual}</span><br><span>Forecast: </span><span class="tooltipForecast" style="color: ${flagColour};">${forecast != 'null'? forecast : 'n/a'}</span>`,
						}
						if (isEPS) {
							currentEventData.text = `<span class="tooltipDate">FY ${refDate}</span><br><span class="tooltipText" style="color: ${flagColour};">${name}</span><br><span>Actual: </span><span class="tooltipActual" style="color: ${flagColour};">${close}</span><br>`
						}
						updatedData.push(currentEventData)
						
					})
					tempFlagSeries[tempSeriesIndex].data = updatedData
				}
			})
		}
			tempFlagSeries.forEach((item) => {
				_th.chart.addSeries(item)
			})
			setTimeout(()=>{
				let endSerArr = _th.chart.series.length - 1
				_th.chart.series[1].update({index: endSerArr})
				plotEvents = true
				_th.chart.exportChart({type: 'image/png'})
				plotEvents = false
			}, 0)
			if (noDuplAnnotAfterFlags) {
				recreateAnnotationAfterFlags()
				noDuplAnnotAfterFlags = false
			}
}
};

function transformData(type, structure_array, result) {
	switch (type) {
		case 'markets':
			result.series.forEach(function (ele) {
					const treated_data = []
					ele.data.forEach(function (item) {
						const treated_datapoint = {}
						item.forEach(function (el, index) {
							if (index > 0) {
								treated_datapoint[structure_array[index]] = el
							} else {
								treated_datapoint[structure_array[index]] = el * 1000
								treated_datapoint.date = formatDate(el * 1000)
							}
						})
						treated_data.push(treated_datapoint)
					})
					ele.data = treated_data
				
		
				if (ele.type == 'te') {
					ele.data = ele.data.reverse()
				}
			})
			return result
		case 'calendar':
					let treated_data_calendar = []
					result.forEach(function (item) {
						const treated_datapoint = {}
						item.forEach(function (el, index) {
							if (index != 3) {
								treated_datapoint[structure_array[index]] = el
							} else {
								treated_datapoint[structure_array[index]] = el * 1000
								treated_datapoint.date = formatDate(el * 1000)
							}
						})
						treated_data_calendar.push(treated_datapoint)
					})
					result = treated_data_calendar
				return result
		case 'earnings':
					let treated_data_earnings = []
					result.forEach(function (item) {
						const treated_datapoint = {}
						item.forEach(function (el, index) {
							if (index != 1) {
								treated_datapoint[structure_array[index]] = el
							} else {
								treated_datapoint[structure_array[index]] = el * 1000
								treated_datapoint.date = formatDate(el * 1000)
							}
						})
						treated_data_earnings.push(treated_datapoint)
					})
					result = treated_data_earnings
				
				return result
		default:
			return result
	}
}

function formatDate(timestamp) {
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}